module.exports = __webpack_public_path__ + "img/sweeper_cleaner.ee56b211.jpg";